import { createContext } from 'react';

import { ForeignKey } from '@totem/types/common';

interface Context {
  loading: boolean;
  data: ForeignKey[];
  controlSystemId: string;
  requestRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  controlSystemId: '',
  requestRefresh: () => {},
});
